import React, { useEffect, useState } from "react";
import { getUserData } from "services/indexcServices";
import { useMediaQuery } from "react-responsive";

const PesquisaIndecx: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 620 });
  const [userData, setUserData] = useState<any>(null);

  useEffect(() => {
    const fetchUserData = async (): Promise<void> => {
      const data = await getUserData();
      if (data) {
        setUserData(data);
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const scriptId = "indecx-widget-js";
    const widgetContainerId = "indecx-widget-container";
    const widgetMinimizedId = "indecx-widget-minimized";

    const adjustWidgetPosition = (): void => {
      const widget = document.getElementById(widgetContainerId);
      const widgetMinimized = document.getElementById(widgetMinimizedId);
      if (!widget && !widgetMinimized) return;

      if (widget && isMobile) {
        widget.style.setProperty("right", "100px");
      } else if (widget) {
        widget.style.setProperty("right", "150px");
      }

      if (widgetMinimized) {
        widgetMinimized.style.setProperty(
          "right",
          isMobile ? "100px" : "150px",
          "important"
        );
      }
    };

    const loadWidget = (): void => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) existingScript.remove();

      const existingWidgetContainer =
        document.getElementById(widgetContainerId);
      if (existingWidgetContainer) existingWidgetContainer.remove();
      const existingWidgetMinimized =
        document.getElementById(widgetMinimizedId);
      if (existingWidgetMinimized) existingWidgetMinimized.remove();

      // Buscar dados do primeiro endereço ativo ou usar fallback do localStorage
      const firstAddress = userData?.customerAddresses?.[0];
      const phoneContact = firstAddress?.contacts?.find(
        (c) => c.contactType === "CELL" || c.contactType === "PHONE"
      );
      const emailContact = firstAddress?.contacts?.find(
        (c) => c.contactType === "EMAIL"
      );

      const config = {
        key: "5e46926028a0ef00ed5fc759",
        action: "61794f29945586195bd57ab7",
        name:
          userData?.corporateName ||
          localStorage.getItem("@UltragazEmpresarial:customerName") ||
          "",
        email:
          userData?.email ||
          emailContact?.contact ||
          localStorage.getItem("@UltragazEmpresarial:loginEmail") ||
          "",
        phone:
          phoneContact?.contact ||
          (userData?.phoneDdd && userData?.phoneNumber
            ? `${userData.phoneDdd}${userData.phoneNumber}`
            : "") ||
          localStorage.getItem("@UltragazEmpresarial:phone") ||
          "",
        indicators: {
          cpf_cnpj:
            userData?.document ||
            localStorage.getItem("@UltragazEmpresarial:document") ||
            "CPF_INFO",
          codCliente:
            userData?.customerCode ||
            localStorage.getItem("@UltragazEmpresarial:customerCode") ||
            "COD_CLIENTE",
          codEndereco:
            userData?.customerSiteId ||
            firstAddress?.siteId ||
            localStorage.getItem("@UltragazEmpresarial:customerSiteId") ||
            "COD_ENDERECO",
          estado:
            firstAddress?.stateCode ||
            localStorage.getItem("@UltragazEmpresarial:estado") ||
            "ESTADO",
          cidade:
            firstAddress?.city ||
            localStorage.getItem("@UltragazEmpresarial:cidade") ||
            "CIDADE",
        },
      };

      const script = document.createElement("script");
      script.id = scriptId;
      script.src =
        "https://indecx-widget.s3.amazonaws.com/widget-production-v3.js";
      script.type = "text/javascript";
      script.async = true;

      script.onload = () => {
        try {
          const { IndeCX } = window as any;
          if (!IndeCX) {
            return;
          }
          IndeCX(config);

          setTimeout(() => {
            adjustWidgetPosition();
          }, 500);
        } catch (error) {
          console.error("Erro ao inicializar IndeCX widget:", error);
        }
      };

      document.body.appendChild(script);
    };

    if (userData !== null) {
      loadWidget();
    }

    return () => {
      const scriptEl = document.getElementById(scriptId);
      if (scriptEl) scriptEl.remove();

      const widgetContainer = document.getElementById(widgetContainerId);
      if (widgetContainer) widgetContainer.remove();

      const widgetMin = document.getElementById(widgetMinimizedId);
      if (widgetMin) widgetMin.remove();
    };
  }, [isMobile, userData]);

  return null;
};

export { PesquisaIndecx };
